import { motion } from "framer-motion";
import styled, { css } from "styled-components";
import { scaledPx } from "@ui/styles/utils";

export interface RectangleProps {
	color: string;
	width?: number;
	height?: number;
	radius?: number;
	angle?: number;
	top?: number;
	left?: number;
	right?: number;
	bottom?: number;
}

export const Rectangle = styled(motion.div)<RectangleProps>`
	position: absolute;
	${({ color, width, height, radius, top, left, right, bottom, angle }) => css`
		${width && `width: ${scaledPx(width)}`};
		${height && `height: ${scaledPx(height)}`};
		${radius && `border-radius: ${scaledPx(radius)}`};
		${top !== undefined && `top: ${scaledPx(top)}`};
		${left !== undefined && `left: ${scaledPx(left)}`};
		${right !== undefined && `right: ${scaledPx(right)}`};
		${bottom !== undefined && `bottom: ${scaledPx(bottom)}`};
		${angle !== undefined && `transform: rotate(${angle}deg)`};
		background-color: ${color};
	`}
`;
